import React from 'react';
import './CardCategory.css';

import { useSelector } from 'react-redux';
import { translate } from '../../../i18n';
import { RootState } from '../../../store';

interface ICardCategoryProps {
    frenchTitle: string;
    englishTitle: string;
    index: number;
    activeTab: boolean;
    setSelectedTab: (index: number) => void;
}
const CardCategory: React.FC<ICardCategoryProps> = (props) => {
    const { language } = useSelector((state: RootState) => state.lang);

    const title = language === 'EN' ? props.englishTitle : props.frenchTitle;

    return (
        <button onClick={() => props.setSelectedTab(props.index)} className={props.activeTab ? 'CardCategoryOuter active Drop-Shadow' : 'CardCategoryOuter Drop-Shadow'}>
            <div className="CardCategoryTitle">{title}</div>
        </button>
    );
};

export default CardCategory;
